@if (isVisible()) {
    <div class="flex flex-col gap-[2px]">
        <button
            type="button"
            class="sidebar-row flex h-[24px] w-full cursor-pointer items-center gap-[8px] rounded-[4px] pr-[9px] pl-[9px] text-left text-[0.6875rem]/tight font-semibold tracking-[0.06em] text-(--p-surface-400) uppercase transition-colors duration-200 select-none hover:bg-(--p-navigation-item-focus-background) dark:text-(--p-surface-500)"
            (click)="onToggleCollapsed()"
        >
            <span class="grow">Shortcuts</span>
            <span [class.rotate-180]="!isCollapsed()" class="material-symbols-outlined shrink-0 text-[16px]/tight! transition-transform duration-200">keyboard_arrow_down</span>
        </button>

        @if (!isCollapsed()) {
            <ul class="flex flex-col gap-[2px]">
                @for (row of shortcutRows(); track row.item.routerLink) {
                    <li>
                        <a
                            class="sidebar-row text-color flex h-[26px] cursor-pointer items-center gap-[8px] rounded-[4px] pr-[9px] pl-[9px] text-[0.95rem]/tight font-normal transition-colors duration-200 hover:bg-(--p-navigation-item-focus-background)"
                            [routerLink]="row.item.routerLink"
                            [queryParams]="routerLinkQueryParams()"
                            (click)="onNavigate()"
                        >
                            <span class="material-symbols-outlined shrink-0 text-[15px]/tight! text-(--p-surface-400) dark:text-(--p-surface-500)">{{ row.isPinned ? 'keep' : 'history' }}</span>
                            <span class="min-w-0 grow truncate" [attr.title]="row.item.label">{{ row.item.label }}</span>
                            @if (canPin()) {
                                <button
                                    type="button"
                                    class="sidebar-pin-button flex h-[20px] w-[20px] shrink-0 cursor-pointer items-center justify-center rounded-[3px] border-0 bg-transparent p-0 text-(--p-surface-400) hover:text-(--p-text-color) disabled:cursor-default disabled:opacity-40 dark:text-(--p-surface-500)"
                                    [disabled]="!row.isPinned && shortcutsService.isPinnedAtCap()"
                                    [attr.title]="shortcutsService.getPinActionTitle(row.isPinned)"
                                    (click)="onTogglePinned($event, row.item.routerLink)"
                                >
                                    <span class="material-symbols-outlined text-[15px]/none!">{{ row.isPinned ? 'keep_off' : 'keep' }}</span>
                                </button>
                            }
                        </a>
                    </li>
                }
            </ul>
        }
    </div>
}
